import React, { useState } from 'react'

const Paintfilter={
    searchBoxInputName:'',
    searchBoxInputCmp:'',
    searchBoxInputOwner:'',
    findbyIdname:''

}

export const PaintfilterState={
   Paintfilter 
}